<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" offset-y :attach="attach !== undefined" max-height="345")
    template(#activator="{ on, attrs }")
      v-sheet.text-md.round-xl.border-menu(v-bind="attrs" v-on="on" flat outlined height="48" min-width="240")
        .d-flex.align-center.fill-height.px-4
          div.flex-grow-1(v-if="value")
            .text-md.text-left(style="font-size: 15px !important;") {{ getRoomName(value) }}
          .text-sm.flex-grow-1.neutral500--text.text-left(v-else) Select room
          v-icon(size="24") $yzi-chevron-down
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined placeholder="Search room" dense hide-details autofocus)
        v-divider
        div.d-flex.align-center.px-4.py-3(@click="createNewRoom")
          div.text-sm.flex-grow-1.font-semibold.neutral700--text.clickable.underline Create new room
        v-divider
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      div(v-for="item in filteredItems")
        div.d-flex.align-center.px-4.py-3(v-if="isItemDisabled(item)" style="background-color: var(--v-neutral300)")
          div.text-sm.flex-grow-1.neutral700--text {{ item.name }}
        div.d-flex.align-center.px-4.py-3.clickable.hover-bg(v-else @click="selectItem(item)")
          div.text-sm.flex-grow-1.neutral700--text {{ item.name }}
          v-btn(x-small icon color="transparent" @click.stop="deleteItem(item)")
            v-icon(small color="neutral500") mdi-close
        v-divider
      template(v-if="!filteredItems.length")
        .px-4.py-3 No results match

  .dialogs
    add-new-room-dialog(v-if="openDialog" :open.sync="openDialog" @closed="openDialog = false")
    delete-facility-dialog(v-if="openDeleteDialog" :open.sync="openDeleteDialog" :facility="selectedItem")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddNewRoomDialog from '@/components/clinic/dialogs/AddNewRoomDialog.vue'
import DeleteFacilityDialog from '@/components/clinic/dialogs/DeleteFacilityDialog.vue'

export default {
  components: { AddNewRoomDialog, DeleteFacilityDialog },
  props: ['value', 'attach'],
  data: () => ({
    isLoading: false,
    isFetching: false,
    openDialog: false,
    openDeleteDialog: false,
    show: false,
    selectedItem: null,
    itemName: null,
    rooms: [],
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    filteredItems() {
      if (this.itemName) {
        const keyword = this.itemName.toLowerCase()
        return this.rooms.filter(item => (item.name.toLowerCase().includes(keyword)))
      }
      return this.rooms
    },
  },
  watch: {
    show (val) {
      if (val) {
        this.fetchRooms()
      } else {
        this.itemName = null
        this.$emit('closed')
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchRooms () {
      this.isFetching = true
      const params = {
        type: 'room',
        fields: 'id,name',
        page_size: -1
      }
      this.$axios.get(`/clinics/${this.company.slug}/facilities`, { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.rooms = resp.data.results
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    createNewRoom () {
      this.show = false
      this.openDialog = true
    },
    getRoomName (val) {
      let name = null
      if (this.rooms.length) {
        let room = this.rooms.find(f => f.id === val)
        if (room) {
          name = room.name
        }
      }
      return name
    },
    selectItem (item) {
      this.$emit('input', item.id)
      this.$emit('change')
      this.show = false
      this.itemName = null
    },
    isItemDisabled(item) {
      return this.value === item.id
    },
    deleteItem (item) {
      this.selectedItem = item
      this.openDeleteDialog = true
      this.show = false
    },
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
</style>